import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { dataActions } from "./actions";
import { DataState } from "./types";

const initialState: DataState = {
  menus: [],
  registrationResults: [],
  maintenance: {
    title: "",
    message: "",
    footer_message: "",
    start_date: "",
    end_date: "",
    is_maintenance: false,
  },
};

export function DataReducer(state = initialState, action: Action): DataState {
  if (isType(action, dataActions.resetToInitialState)) {
    return initialState;
  }

  if (isType(action, dataActions.getMenus.done)) {
    return {
      ...state,
      menus: action.payload.result.data,
    };
  }

  if (isType(action, dataActions.getMaintenanceJson.done)) {
    return {
      ...state,
      maintenance: action.payload.result,
    };
  }

  if (isType(action, dataActions.getRegistrationResults.done)) {
    return {
      ...state,
      registrationResults: action.payload.result.data,
    };
  }

  return state;
}
